import { AxiosCancelablePromise, ApiData } from './utils/axiosWrapper'
import service from './index'
import baseUrl from '-/services/config/baseUrl'

export interface PostV1UserGetVerifyCodeRequestBody {
  /**
   * 手机号码
   */
  phone: string
  /**
   * 提醒类型
   */
  noticeWay: string
  /**
   * 用途：register change_phone bind_phone login update_password
   */
  useType: string
  /**
   * 图形验证码
   */
  captcha?: string
  /**
   * 用户平台
   */
  userPlatform?: string
  /**
   * 滑块图形验证码
   */
  captchaVerification?: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PostV1UserGetVerifyCodeResponse {}

export interface PostV1UserCheckVerifyCodeRequestBody {
  /**
   * 用户类型
   */
  userPlatform: string
  /**
   * 手机号码
   */
  phone: string
  /**
   * 用途：register change_phone bind_phone login update_password
   */
  useType: string
  /**
   * 验证码
   */
  code: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PostV1UserCheckVerifyCodeResponse {}

export interface PostV1LoginRequestBody {
  /**
   * 账号：手机号或邮箱
   */
  account: string
  /**
   * 密码
   */
  password: string
}
export interface PostV1RegisterRequestBody {
  /**
   * 账号：手机号
   */
  account: string
  /**
   * 用户名
   */
  username: string
  /**
   * 验证码
   */
  verifyCode: string
}

export interface PostV1LoginResponse {
  /**
   * 用户 ID
   */
  userId: number
  /**
   * Session ID
   */
  sessionId: string
  /**
   * 角色 ID
   */
  role: number
  /**
   * 用户权限
   */
  permissions: string[]
}

export interface PostV1LogoutRequestBody {
  /**
   * Session ID
   */
  sess: string
  /**
   * platform
   */
  platform: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PostV1LogoutResponse {}

/**
 * 获取短信验证码
 */
export const postV1UserGetVerifyCode = (
  params: PostV1UserGetVerifyCodeRequestBody
): AxiosCancelablePromise<ApiData<PostV1UserGetVerifyCodeResponse>> =>
  service.post('/passport-interface/verify_code/get', params, { baseURL: baseUrl.passportAPI })

/**
 * 校验短信验证码
 */
export const postV1UserCheckVerifyCode = (
  params: PostV1UserCheckVerifyCodeRequestBody
): AxiosCancelablePromise<ApiData<PostV1UserCheckVerifyCodeResponse>> =>
  service.post('/passport-interface/verify_code/check', params, { baseURL: baseUrl.passportAPI })

/**
 * 用户登录
 */
export const postV1UserLogin = (
  params: PostV1LoginRequestBody
): AxiosCancelablePromise<ApiData<PostV1LoginResponse>> =>
  service.post('/passport-interface/cloud_pharmacy/user/login', params, {
    baseURL: baseUrl.passportAPI,
  })
/**
 * 用户注册
 */
export const postV1UserRegister = (
  params: PostV1RegisterRequestBody
): AxiosCancelablePromise<ApiData<PostV1LoginResponse>> =>
  service.post('/passport-interface/cloud_pharmacy/user/register', params, {
    baseURL: baseUrl.passportAPI,
  })

/**
 * 用户退出登录
 */
export const postV1UserLogout = (
  params: PostV1LogoutRequestBody
): AxiosCancelablePromise<ApiData<PostV1LogoutResponse>> =>
  service.post('/passport-interface/cloud_pharmacy/user/logout', params, {
    baseURL: baseUrl.passportAPI,
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      platform: params.platform,
      sessionId: `sess=${params.sess}`,
    },
  })
